import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import fr from 'date-fns/locale/fr';
import InputMask from "react-input-mask";
registerLocale('fr', fr)

export const CustomDatePicker = ({selected, onChange, minDate, placeholder, readOnly=false}) => {
  return (
    <>
      <DatePicker
        locale="fr"
        customInput={
          <InputMask
            readOnly
            className="DateField DRInput-Class"
            type="text" mask="99/99/9999" />
        }
        dateFormat="dd/MM/yyyy"
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        selected={selected}
        onChange={onChange}
        minDate={minDate}
        placeholderText={placeholder}
        readOnly={readOnly}
      />
    </>
  );
};
export default CustomDatePicker;